const processEnv=()=>{          //接口环境
    switch(process.env.NODE_ENV){
        // case 'development': return 'http://172.16.100.164:8848/api';            //开发(tommy)
        // case 'development': return 'http://172.16.100.63:2444/api';             //开发(orange)
        // case 'development': return 'http://172.16.100.118:9527/api';             
        case 'production': return assApi.url;    //生产
        default : return assApi.url;
    }
}
// 请求地址配置
const requestUrlConfig = {
    getDepartmentList: '/template/getDepartmentList', // 获取部门列表
    getFormTempList: '/template/getList', // 获取评分表模板列表
    createFormTemp: '/template/create', // 创建评分表模板
    deleteFormTemp: '/template/delete', // 删除评分表模板
}
const configUrl={
    baseURL:processEnv(),
}

export {
    requestUrlConfig,
    configUrl
}